import React from 'react';
import { IconProps } from '.';

const SvgDownload = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M12.75 3v9.44l3.846-3.847 1.06 1.06L12 15.312 6.343 9.654l1.06-1.06 3.847 3.845V3h1.5Z' />
      <path fill={color} d='M4.5 14.75H3V21h18v-6.25h-1.5v4.75h-15v-4.75Z' />
    </svg>
  );
};

export default SvgDownload;
